"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegionalFull_1 = require("./view/RegionalFull");
var isRegionalOptionDirty_1 = require("./utils/isRegionalOptionDirty");
var React = require("react");
var discardRegionalOption_1 = require("./data/mutators/discardRegionalOption");
var saveRegionalOption_1 = require("./orchestration/saveRegionalOption");
var RegionalOption = {
    key: 'regional',
    titleStringKey: 'optionTitle_regional',
    searchTermsStringKey: 'optionTitle_regional',
    fullOptionFormSettings: {
        render: function () { return React.createElement(RegionalFull_1.default, null); },
        isDirty: isRegionalOptionDirty_1.default,
        onSave: saveRegionalOption_1.default,
        onDiscard: discardRegionalOption_1.default,
    },
};
exports.default = RegionalOption;
//# sourceMappingURL=RegionalOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/RegionalOption.js
// module id = 4925
// module chunks = 2